// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid-row-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 24px;
}

.vm-20 {
  margin: 20px 0;
}

.divider-0 {
  width: 100%;
  height: 1px;
  background-color: #d0d7dd;
}

.rel {
  position: relative;
}

.flex {
  display: flex;
}

.jcc {
  justify-content: center !important;
}

html {
  font-family: "SFProDisplay", sans-serif;
  font-size: 14px;
  color: #000000;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

body {
  min-width: 100vw;
  min-height: 100vh;
  position: relative;
  overflow-x: hidden;
  font-family: "SFProDisplay";
  color: #000000;
}

body,
h1,
h2,
h3,
h4,
p,
ul[class],
ol[class],
li,
figure,
figcaption,
blockquote,
dl,
dd {
  margin: 0;
}

a {
  display: block;
  font-size: 14px;
  text-align: center;
  text-decoration: none;
  width: 100%;
}
a:hover {
  cursor: pointer;
}

button,
input,
textarea,
select {
  font-family: inherit;
}

.display-none {
  display: none;
}

.container {
  padding: 0 204px;
  margin-top: 24px;
}

.local-container {
  width: 100%;
  padding: 32px 204px;
}

.outer-container {
  width: 100%;
  padding: 32px 204px;
}

.full-width {
  width: 100%;
}

.pagination {
  margin-top: 48px;
}

.long-string {
  display: inline-block;
  max-width: 200px !important;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.short-string {
  display: inline-block;
  max-width: 100px !important;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

/* width */
::-webkit-scrollbar {
  width: 6px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f5faff;
}

/* Handle */
::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: #d1d5df;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #d5d5d6;
}

.details {
  display: flex;
  flex-direction: column;
  position: relative;
}
.details__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 32px 204px 48px;
}
.details__body {
  display: flex;
  flex-direction: column;
  padding: 0 204px;
}
.details__body .row {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}
.details__body .row .detail {
  display: flex;
  flex-direction: column;
  width: 33%;
  padding-right: 30px;
  margin-bottom: 33px;
}
.details__body .row .detail_full {
  width: 100% !important;
}
.details__body .row .detail__content-title {
  margin-bottom: 16px;
}
.details__divider {
  width: 100%;
  height: 1px;
  background-color: #d0d7dd;
  margin: 8px 0 40px;
}

.divider {
  width: 100%;
  height: 1px;
  background-color: #d0d7dd;
  margin: 8px 0 40px;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}`, "",{"version":3,"sources":["webpack://./src/assets/helpers/grid.scss","webpack://./src/assets/global.scss","webpack://./src/assets/helpers/colors.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;ACAF;;ADIA;EACE,cAAA;ACDF;;ADKA;EACE,WAAA;EACA,WAAA;EACA,yBEVM;ADQR;;ADMA;EACE,kBAAA;ACHF;;ADMA;EACE,aAAA;ACHF;;ADMA;EACE,kCAAA;ACHF;;AAxBA;EACE,uCAAA;EACA,eAAA;EACA,cCkBS;ADSX;;AAxBA;;;EAGE,sBAAA;AA2BF;;AAxBA;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,2BAAA;EACA,cCOM;ADoBR;;AAxBA;;;;;;;;;;;;;;EAcE,SAAA;AA2BF;;AAxBA;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;AA2BF;AAzBE;EACE,eAAA;AA2BJ;;AAvBA;;;;EAIE,oBAAA;AA0BF;;AAvBA;EACE,aAAA;AA0BF;;AAvBA;EACE,gBAAA;EACA,gBAAA;AA0BF;;AAvBA;EACE,WAAA;EACA,mBAAA;AA0BF;;AAvBA;EACE,WAAA;EACA,mBAAA;AA0BF;;AAvBA;EACE,WAAA;AA0BF;;AAvBA;EACE,gBAAA;AA0BF;;AAvBA;EACE,qBAAA;EACA,2BAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AA0BF;;AAvBA;EACE,qBAAA;EACA,2BAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AA0BF;;AAtBA,UAAA;AACA;EACE,UAAA;AAyBF;;AAtBA,UAAA;AACA;EACE,mBC3GS;ADoIX;;AAtBA,WAAA;AACA;EACE,kBAAA;EACA,mBC7GM;ADsIR;;AAtBA,oBAAA;AACA;EACE,mBC3GW;ADoIb;;AArBA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;AAwBF;AAtBE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,wBAAA;AAwBJ;AArBE;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AAuBJ;AArBI;EACE,aAAA;EACA,eAAA;EACA,WAAA;AAuBN;AArBM;EACE,aAAA;EACA,sBAAA;EACA,UAAA;EACA,mBAAA;EACA,mBAAA;AAuBR;AArBQ;EACE,sBAAA;AAuBV;AAnBU;EACE,mBAAA;AAqBZ;AAdE;EACE,WAAA;EACA,WAAA;EACA,yBCpKI;EDqKJ,kBAAA;AAgBJ;;AAZA;EACE,WAAA;EACA,WAAA;EACA,yBC5KM;ED6KN,kBAAA;AAeF;;AAZA,gCAAA;AACA;;EAEE,wBAAA;EACA,SAAA;AAeF;;AAZA,YAAA;AACA;EACE,0BAAA;AAeF","sourcesContent":["// grid\n.grid-row-2 {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  column-gap: 24px;\n}\n\n// paddings, margins\n.vm-20 {\n  margin: 20px 0;\n}\n\n// elements\n.divider-0 {\n  width: 100%;\n  height: 1px;\n  background-color: $gray5;\n}\n\n// helpers\n.rel {\n  position: relative;\n}\n\n.flex {\n  display: flex;\n}\n\n.jcc {\n  justify-content: center!important;\n}","@import './helpers/index.scss';\n\nhtml {\n  font-family: 'SFProDisplay', sans-serif;\n  font-size: 14px;\n  color: $headText;\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\nbody {\n  min-width: 100vw;\n  min-height: 100vh;\n  position: relative;\n  overflow-x: hidden;\n  font-family: 'SFProDisplay';\n  color: $black;\n}\n\nbody,\nh1,\nh2,\nh3,\nh4,\np,\nul[class],\nol[class],\nli,\nfigure,\nfigcaption,\nblockquote,\ndl,\ndd {\n  margin: 0;\n}\n\na {\n  display: block;\n  font-size: 14px;\n  text-align: center;\n  text-decoration: none;\n  width: 100%;\n\n  &:hover {\n    cursor: pointer;\n  }\n}\n\nbutton,\ninput,\ntextarea,\nselect {\n  font-family: inherit;\n}\n\n.display-none {\n  display: none;\n}\n\n.container {\n  padding: 0 $horizontalPadding;\n  margin-top: 24px;\n}\n\n.local-container {\n  width: 100%;\n  padding: 32px $horizontalPadding;\n}\n\n.outer-container {\n  width: 100%;\n  padding: 32px $horizontalPadding;\n}\n\n.full-width {\n  width: 100%;\n}\n\n.pagination {\n  margin-top: 48px;\n}\n\n.long-string {\n  display: inline-block;\n  max-width: 200px!important;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.short-string {\n  display: inline-block;\n  max-width: 100px!important;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n// custom scroll bar\n/* width */\n::-webkit-scrollbar {\n  width: 6px;\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n  background: $scrollBg;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  border-radius: 8px;\n  background: $scroll;\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: $scrollHover;\n}\n\n// Details pages\n.details {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n\n  &__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 32px $horizontalPadding 48px;\n  }\n\n  &__body {\n    display: flex;\n    flex-direction: column;\n    padding: 0 $horizontalPadding;\n\n    .row {\n      display: flex;\n      flex-wrap: wrap;\n      width: 100%;\n\n      .detail {\n        display: flex;\n        flex-direction: column;\n        width: 33%;\n        padding-right: 30px;\n        margin-bottom: 33px;\n\n        &_full {\n          width: 100%!important;\n        }\n\n        &__content {\n          &-title {\n            margin-bottom: 16px;\n          }\n        }\n      }\n    }\n  }\n\n  &__divider {\n    width: 100%;\n    height: 1px;\n    background-color: $gray5;\n    margin: 8px 0 40px;\n  }\n}\n\n.divider {\n  width: 100%;\n  height: 1px;\n  background-color: $gray5;\n  margin: 8px 0 40px;\n}\n\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number] {\n  -moz-appearance: textfield;\n}","//  Color scheme\n$white: #ffffff;\n$whiteGray: #f2f4f7;\n$halfGray: #f5faff;\n$grayWhite: #e7e9eb;\n$gray2: #e9eaea;\n$gray5: #d0d7dd;\n$gray7: #d1d5df;\n$gray8: #f4f4f4;\n$gray13: #f8f9fa;\n$gray12: #e0e1e9;\n$gray9: #cbcdd0;\n$gray10: #E1E5EA;\n$gray11: #1F1F22;\n$shadowGray: #d5d5d6;\n$shadowGray2: rgba(25, 27, 35, 0.15);\n$gray3: #c4c4c4;\n$lightGray: #aab1ba;\n$gray4: #878b90;\n$gray6: #7d838a;\n$gray14: #F6F6F6;\n$grayAsphalt: #344045;\n$gray: #808185;\n$textGray: #000000;\n$black1: #0b1f33;\n$black2: #333F48;\n\n$black: #000000;\n\n$lightGreen: #a4eedc;\n$green3: #5dc8ba;\n$green: #21ba72;\n$green0: #30BA9A;\n$green0-0_5: rgba(48, 186, 154, 0.50);\n$green4: #62BDCA;\n$darkGreen: #209f6d;\n$green2: #21a19a;\n$prGreen: #00809C;\n$lightBlue: #d8ebfe;\n$blue: #1358bf;\n$red: #ee505a;\n$red0_5: rgba(238, 80, 90, 0.5);\n$red1: #EC1B28;\n$beige: rgba(255, 205, 156, 0.6);\n$yellow: #FFE5CD;\n\n// gradients\n$defaultGradient: linear-gradient(\n                56.46deg,\n                #a4eedc -45.58%,\n                #5bcab5 19.1%,\n                #6baae4 100%\n);\n$gradientLight: linear-gradient(56.46deg, #A4EEDC -45.58%, #5BCAB5 19.1%, #6BAAE4 100%);\n$gradient2: linear-gradient(\n                270deg,\n                rgba(224, 241, 254, 0.4) 0%,\n                rgba(212, 248, 239, 0.4) 49.63%,\n                rgba(199, 247, 233, 0.4) 100%\n);\n$gradient3: linear-gradient(225deg, #eef181 0%, #92dd90 51.47%, #4de9cb 100%);\n$gradient4: linear-gradient(\n                270deg,\n                rgba(224, 241, 254, 0.3) 0%,\n                rgba(212, 248, 239, 0.3) 49.63%,\n                rgba(199, 247, 233, 0.3) 100%\n);\n$gradient5: linear-gradient(270deg, #E0F1FE 0%, #D4F8EF 49.63%, #C7F7E9 100%);\n$gradient6: linear-gradient(270deg, #E0F1FE 0%, #D4F8EF 49.63%, #C7F7E9 100%);\n$gradientPlaceholder: linear-gradient(90deg, rgba(255,255,255,0) -10%, rgba(255,255,255,1) 50%);\n$gradientPlaceholderDisabled: linear-gradient(90deg, rgb(163 224 219 / 18%) -10%, rgb(233 234 234) 50%);\n$boxShadowModal: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n$gradientDanger: linear-gradient(94.6deg, #FEA4A4 0.09%, #EE6767 100.09%);\n$gradientOrange: linear-gradient(91.58deg, #FFB973 0.03%, #FFA244 100.03%);\n$mainPageBackground: linear-gradient(180deg, rgba(255, 255, 255, 0) 61.86%, rgba(255, 255, 255, 0.8) 100%), radial-gradient(10.51% 41.68% at 32.4% 13.32%, rgba(33, 186, 114, 0.36) 0%, rgba(33, 186, 114, 0) 100%) /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */\n, radial-gradient(33.57% 117.61% at 63.33% -9.67%, rgba(90, 177, 255, 0.24) 0%, rgba(0, 135, 205, 0.24) 0.01%, rgba(0, 135, 205, 0) 100%) /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */\n, radial-gradient(19.56% 68.52% at -4.53% 77.65%, rgba(255, 224, 102, 0.3) 0%, rgba(255, 224, 102, 0) 100%), linear-gradient(90deg, rgba(66, 227, 180, 0.34) 0%, rgba(107, 234, 199, 0.34) 49.98%, rgba(155, 208, 254, 0.34) 100%), #FFFFFF;\n//  color vars\n$borderOpacityColor: rgba(214, 214, 215, 0.5);\n$boxShadowColor: rgba(0, 0, 0, 0.08);\n$footerColor: #f8fefc;\n$nonActiveText: $gray9;\n\n$primary: $green;\n$main: $white;\n$scrollBg: $halfGray;\n$scroll: $gray7;\n$scrollHover: $shadowGray;\n$editorMenuHover: $halfGray;\n$border: $gray5;\n\n$mainText: $black;\n$headText: $textGray;\n$smallText: $gray6;\n$tableSmallText: $gray4;\n$blockTitle: $black1;\n$calendarGradient: $gradient5;\n$chartActiveBg: $gradient3;\n$nonActiveElement: $gray8;\n\n$secondaryColor: $lightGray;\n$borderColor: $grayWhite;\n$tooltipBorder: $gray12;\n$tooltipShadow: $shadowGray2;\n$danger: $red;\n$serviceDanger: $red1;\n$mainBtnDanger: $gradientDanger;\n$action: $prGreen;\n$bgAction: lighten($lightGreen, 15%);\n$inputBorderColor: $shadowGray;\n$selectBorderColor: $gray10;\n$documentButton: $gray2;\n$tagBackground: $whiteGray;\n$cardShadow: $boxShadowModal;\n$textSelected: $lightBlue;\n$menuHover: $gradient5;\n$blockBg: $gray13;\n$toggleBg: $gradientLight;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
